import { getOsFilter, getYesNoOptions } from "@/helpers/filters.helper"
import {
  getSeverityFilter,
  InventoryFilters
} from "@/pages/DiscoveryPage/utils/filters.utils"

import type { TFunction } from "@/hooks/useTranslation"

export const getFilters = (
  t: TFunction,
  environmentOptions?: { label: string; value: string }[]
) => {
  const keyValues = "filters.helpers.multipleValues"

  return [
    getSeverityFilter(),
    InventoryFilters.environment(t, environmentOptions),
    getOsFilter(t),
    {
      key: "instanceType",
      label: t("filters.instanceType"),
      type: "input",
      helper: [
        {
          label: t(keyValues, { label: t("filters.instanceType") }),
          description: t("inventory.generalFilters.multipleSubstring", {
            name: "instance types"
          })
        }
      ]
    },
    {
      key: "autoScalingGroups",
      label: t("filters.instanceGroup"),
      type: "input",
      helper: [
        {
          label: t(keyValues, { label: t("filters.instanceGroup") }),
          description: t("inventory.generalFilters.multipleSubstring", {
            name: "auto scaling groups"
          })
        }
      ]
    },
    {
      key: "imageId",
      label: t("filters.imageId"),
      type: "input",
      helper: [
        {
          label: t(keyValues, { label: t("filters.imageId") }),
          description: t("inventory.generalFilters.multipleSubstring", {
            name: "image ids"
          })
        }
      ]
    },
    {
      key: "instanceId",
      label: t("filters.instanceId"),
      type: "input",
      helper: [
        {
          label: t(keyValues, { label: t("filters.instanceId") }),
          description: t("inventory.generalFilters.multipleSubstring", {
            name: "instance ids"
          })
        }
      ]
    },
    {
      key: "isCorrelatedToProject",
      label: t("filters.correlatedToProject").toLocaleLowerCase(),
      displayLabel: t("filters.correlatedToProject"),
      type: "single",
      options: getYesNoOptions(t)
    }
  ]
}
